/**
 * Round evolution ticks across a zoomable window.
 *
 * The prose pages plot evolution on an axis the user can zoom, so their ticks
 * cannot be the fixed lists they were. The step comes off the 1 / 2 / 2.5 / 5
 * ladder, which keeps the labels values a player would say out loud — 50%,
 * 100%, 250% — at every zoom level.
 */

export function evoTicks(maxEvo: number, target = 6): number[] {
  if (!(maxEvo > 0)) return [0];
  const rough = maxEvo / target;
  const magnitude = 10 ** Math.floor(Math.log10(rough));
  const step =
    [1, 2, 2.5, 5, 10].map((m) => m * magnitude).find((candidate) => candidate >= rough) ??
    magnitude * 10;
  const out: number[] = [];
  for (let value = 0; value <= maxEvo + step * 1e-6; value += step) out.push(value);
  return out;
}
